import { createSlice } from '@reduxjs/toolkit';
import { Account } from '../models/account/account';

interface UserState {
  current: Account | null;
  unreadNotificationCount: number;
}

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    current: null,
    unreadNotificationCount: 0,
  } as UserState,
  reducers: {
    setCurrent: (state, action) => {
      state.current = action.payload;
    },
    setUnreadNotificationCount: (state, action) => {
      state.unreadNotificationCount = action.payload;
    },
  },
});

export const { setCurrent, setUnreadNotificationCount } = userSlice.actions;

export default userSlice.reducer;
